module.exports = __webpack_public_path__ + "static/media/electricity.5a8d7062.svg";